import { Box, SxProps, Theme } from "@mui/material";
import React, { useState } from "react";
import Button from "./Button";
import { APP_MAX_WIDTH } from "../constants/layout";

interface BottomButtonProps {
    children: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    sticky?: boolean;
    sx?: SxProps<Theme>;
    width?: string;
    color?: "primary" | "secondary" | "outlined" | "transparent" | "black";
    variant?: "large" | "big" | "medium" | "small";
    display?: string;
}

//const MIN_LOADING_TIME = 1500; // Artificial delay in milliseconds
const MAX_WIDTH = APP_MAX_WIDTH - (APP_MAX_WIDTH / 100) * 20;

const BottomButton = ({
    children,
    onClick,
    disabled = false,
    sticky = false,
    sx,
    width = "80%",
    color = "primary",
    variant = "large",
    display = "flex",
}: BottomButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
        if (!onClick) return;

        setLoading(true); // Start loading animation
        await onClick(e); // Execute the onClick function
        setLoading(false); // End loading animation
    };

    return (
        <Box
            sx={{
                position: sticky ? "fixed" : "relative",
                left: sticky ? 0 : undefined,
                right: sticky ? 0 : undefined,
                bottom: sticky ? 0 : undefined,
                marginX: sticky ? "auto !important" : undefined,
                marginBottom: "28px !important", // To leave space for the language switcher temporary
                width: sticky ? "80%" : width,
                maxWidth: sticky ? MAX_WIDTH : undefined,
                padding: "16px",
                display: display,
                justifyContent: "center",
                zIndex: sticky ? 1000 : "auto", // ensure it's above other content when sticky
                ...sx,
            }}
        >
            <Button
                onClick={handleClick}
                disabled={disabled || loading} // Disable button while loading
                color={color}
                variant={variant}
                sx={{
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                }}
                loading={loading}
            >
                {children}
            </Button>
        </Box>
    );
};

export default BottomButton;
